import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
	  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
	return (
	  <div className="flex flex-col items-center justify-center py-12">
	    <Loader2 className="w-8 h-8 animate-spin text-ghana-gold mb-4" />
	    <p className="text-gray-600 text-sm">{message}</p>
	  </div>
	);
};

export default LoadingSpinner;